// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Overview_dropdown__U9jpb","chart":"Overview_chart__2URZf","nav":"Overview_nav__29C7Z","item":"Overview_item__3Azcv","active":"Overview_active__w1Rsy"};